import axios from 'axios';
import { EventType, TeamMemberEvent } from '../types';

const BASE = '/api/team-insights/events';

export interface ListEventsParams {
    from?: string;
    to?: string;
    login?: string;
    type?: EventType;
}

export const listEvents = async (params: ListEventsParams = {}): Promise<TeamMemberEvent[]> => {
    const response = await axios.get<TeamMemberEvent[]>(BASE, { params });
    return response.data;
};

export interface EventInput {
    login: string;
    type: EventType;
    date: string;
    note?: string;
}

export const createEvent = async (input: EventInput): Promise<TeamMemberEvent> => {
    const response = await axios.post<TeamMemberEvent>(BASE, input);
    return response.data;
};

export const updateEvent = async (id: string, input: EventInput): Promise<TeamMemberEvent> => {
    const response = await axios.put<TeamMemberEvent>(`${BASE}/${id}`, input);
    return response.data;
};

export const deleteEvent = async (id: string): Promise<void> => {
    await axios.delete(`${BASE}/${id}`);
};
